// 任务管理
export default {
    unpublished: 'Неопубликовано',
    published: 'Опубликовано',
    inExecution: 'в исполнении',
    completed: 'завершенный',
    deleted: 'удален',
    taskTotal: 'Общее количество задач',
    newTask: 'Новое задание',
    approvalStatus: 'Статус утверждения',
    all: 'все',
    pending: 'В ожидании',
    timeoutNotApproved: 'Тайм-аут не одобрен',
    didNotPass: 'не прошел',
    approved: 'Одобренный',
    generateReport: 'Создать отчет',
    approver: 'Утверждающий',
    reason: 'причина',
    taskNature: 'характер задачи',
    aging: 'старение',
    efficient: 'эффективный',
    invalid: 'неверный',
    onTime: 'вовремя',
    timeOut: 'тайм-аут',
    taskStatus: 'статус задачи',
    model: 'UAV модель',
    mount: 'устанавливать',
    submit: 'представить',
    release: 'выпускать',
    revoke: 'отозвать',
    check: 'Проверить',
    achievementDisplay: 'Дисплей достижений',
    recover: 'восстанавливаться',
    postTask: 'Опубликовать задачу',
    missionReport: 'отчет миссии',
    tip_submit: 'Вы уверены, что хотите отправить?',
    drawingScale: 'масштаб чертежа',
    area: 'площадь',
    mu: 'мю',
    perimeter: 'периметр',
    have: 'имеют',
    without: 'без',
    workLocation: 'расположение работы',
    tip_selectDev: 'Выберите тип устройства',
    tip_selectMount: 'Выберите тип крепления',
    tip_enterDeadline: 'Пожалуйста, введите крайний срок',
    other: 'разное',
    tip_leastOne: 'Пожалуйста, запланируйте хотя бы одно место',
    tip_leastThree: 'Пожалуйста, запланируйте не менее трех пунктов',
    siteName: 'Название сайта',
    selectNumber: 'Количество выбранных точек',
    tip_enterSiteName: 'Пожалуйста, введите название сайта',
    public: 'общественный',
    personal: 'личный',
    personalAndShared: 'личные и общие',
    customize: 'настроить',
    userName: 'имя пользователя',
    tip_userName: 'пожалуйста, введите имя пользователя',
    tip_phoneNumber: 'Пожалуйста, введите номер телефона',
    phoneNumber: 'Телефонный номер',
    department: 'отделение',
    licenseType: 'Тип лицензии',
    systemNotification: 'системное уведомление',
    viewTasks: 'Просмотр задач',
    executor: 'исполнитель',
    uavNumber: 'номер дрона',
    flightTime: 'время полета',
    founder: 'основатель',
    finisher: 'финишер',
    role: 'Роль',
    exportReport: 'отчет об экспорте',
    cumulativeTime: 'Суммарное время',
    taskName: 'название миссии',
    startingPoint: 'отправная точка',
    alreadyHave: 'уже есть',
    new: 'новый',
    mapPickup: 'пикап карты',
    endPoint: 'конец',
    automaticApproval: 'автоматическое одобрение',
}